import { render, staticRenderFns } from "./LoadFail.vue?vue&type=template&id=5869836f"
import script from "./loadFail.js?vue&type=script&lang=js&external"
export * from "./loadFail.js?vue&type=script&lang=js&external"
import style0 from "./LoadFail.vue?vue&type=style&index=0&id=5869836f&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/jenkins_workspace/workspace/vuejs-tb-train-admin-web-sim/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5869836f')) {
      api.createRecord('5869836f', component.options)
    } else {
      api.reload('5869836f', component.options)
    }
    module.hot.accept("./LoadFail.vue?vue&type=template&id=5869836f", function () {
      api.rerender('5869836f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/error/load-fail/LoadFail.vue"
export default component.exports